import type { ImgHTMLAttributes } from 'react';

import { cnm } from 'utils/classNames';

interface Props extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'alt'> {
	src: string | undefined;
}

export default function BlurredImage({
	className,
	loading = 'lazy',
	src,
	...attrs
}: Props) {
	if (!src) {
		return null;
	}
	return (
		<div
			className={cnm('pointer-events-none relative overflow-hidden', className)}
			aria-hidden="true"
		>
			{/* oxlint-disable-next-line next/no-img-element */}
			<img
				{...attrs}
				src={src}
				alt=""
				loading={loading}
				className="absolute -inset-8 h-[calc(100%+4rem)] w-[calc(100%+4rem)] max-w-none object-cover blur-2xl"
			/>
			<div className="absolute inset-0 bg-positive/10" />
		</div>
	);
}
BlurredImage.displayName = 'BlurredImage';
